(() => {
  if (window.cdCategoryMenuReady) return;
  window.cdCategoryMenuReady = true;
  const desktop = window.matchMedia('(min-width: 1025px)');
  const selector = '.vertical-menu .verticalmenu-html > .verticalmenu-list';
  function enhanceMobileCategoryToggle() {
    document.querySelectorAll('.nav-toggle').forEach(toggle => {
      if (toggle.classList.contains('cd-category-toggle')) return;
      toggle.classList.add('cd-category-toggle');
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('tabindex', '0');
      toggle.setAttribute('aria-label', 'Categorías');
      const label = document.createElement('span');
      label.className = 'cd-category-toggle-label';
      label.textContent = 'Categorías';
      toggle.appendChild(label);
      toggle.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle.click();
        }
      });
      const syncExpanded = () => toggle.setAttribute('aria-expanded', String(document.documentElement.classList.contains('nav-open')));
      syncExpanded();
      new MutationObserver(syncExpanded).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    });
  }
  let queued = false;
  function sizeMenus() {
    queued = false;
    if (!desktop.matches) return;
    document.querySelectorAll(selector).forEach(list => {
      const top = list.parentElement.getBoundingClientRect().top;
      const height = Math.max(0, Math.min(480, window.innerHeight - top - 16));
      list.style.setProperty('--cd-category-height', `${height}px`);
    });
  }
  function scheduleSize() {
    if (!queued) { queued = true; requestAnimationFrame(sizeMenus); }
  }
  // Native scrolling handles the list; suppress wheel chaining at either boundary,
  // including lists too short to overflow. Ctrl-wheel remains available for zoom.
  document.addEventListener('wheel', event => {
    if (!desktop.matches || event.ctrlKey || !event.deltaY) return;
    const list = event.target.closest?.(selector);
    if (!list || !list.closest('.vertical-menu.open')) return;
    const atTop = list.scrollTop <= 0;
    const atBottom = list.scrollTop + list.clientHeight >= list.scrollHeight - 1;
    if ((event.deltaY < 0 && atTop) || (event.deltaY > 0 && atBottom)) event.preventDefault();
  }, { passive: false });
  document.addEventListener('click', scheduleSize);
  window.addEventListener('resize', scheduleSize);
  window.addEventListener('scroll', scheduleSize, { passive: true });
  window.addEventListener('load', scheduleSize);
  document.addEventListener('shopify:section:load', scheduleSize);
  document.addEventListener('shopify:section:load', enhanceMobileCategoryToggle);
  enhanceMobileCategoryToggle();
  sizeMenus();
})();
